import { cn } from '@mc/educator-design-system'
import { Image } from '../Image'

export interface ImgCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  src: string
  alt: string
}

export const ImgCard = ({
  title,
  src,
  alt,
  className,
  ...rest
}: ImgCardProps) => (
  <div className={cn('p-4 w-full', className)} {...rest}>
    <h2 className='text-body-1 font-semibold leading-[1.4] font-sans text-white mb-[70px]'>
      {title}
    </h2>
    <div className='relative mx-auto w-full max-w-[356px] aspect-square'>
      <Image
        src={src}
        alt={alt}
        fill
        sizes='(max-width: 767px) 100vw, 356px'
        className='object-contain object-center'
      />
    </div>
  </div>
)
